/** Imports */
import 'whatwg-fetch';
import 'idempotent-babel-polyfill';
// if (!window._babelPolyfill) {
//   require('babel-polyfill');
// }
import * as view from './view.js';
import * as model from './model.js';
import { startWizard } from './wizard.js';
import { verifyDiscount } from './shopifyHelper';
import { Checkout } from './shopify-frontend-api/src/index';
import * as currentExecutingScript from './utils/currentExecutingScript';

/** Initialization */
const currentScriptObj = currentExecutingScript.near();
var currentScript = currentScriptObj.src;
//window.addEventListener('unhandledrejection', function(event) {
//  console.log('Unhandled promise rejection: ', event);
//});
console.dlog = function() {
  let c = getSearchParam('logs');
  if (c) {
    console.log(...arguments);
  }
};

/** Main */
(async () => {
  console.dlog('Controller Main');
  const wizard = getSearchParam('dcodewizard');
  if (wizard) {
    startWizard(wizard);
  } else {
    startSetup();
  }

  const test = getSearchParam('test');
  if (test) {
    window.verifyDiscount = verifyDiscount;
  }
})();

/** Functions */
export async function startSetup(settings, ignoreHiddenAnchor) {
  const { shop, stamp } = getParams();
  settings = settings || (await model.getSettings(shop, stamp));
  console.dlog('Setting up the form with settings:', settings);
  const { appActive, config } = settings;
  const { customSubtotal } = config;
  if (appActive) {
    const existingDiscount = await model.getExistingDiscount();
    view.setupForm(
      settings,
      handleDiscount,
      existingDiscount,
      ignoreHiddenAnchor,
    );
    // Compatability with automatic discount apps like Wheelio
    model.observeHiddenDiscount(handleDiscount);
    await model.saveDiscounts(shop);
    if (existingDiscount) {
      const { title, update } = existingDiscount;
      await handleDiscount(
        title,
        null,
        null,
        update,
        true,
        'INITIAL SETUP',
      );
    }
  }
  if (customSubtotal) view.listenForSubtotalChanges(customSubtotal);
}

function getSearchParam(param) {
  const url_string = window.location.href;
  var url = new URL(url_string);
  return url.searchParams.get(param);
}

export async function handleDiscount(
  discountcode,
  dcodeInput,
  startObserver,
  update,
  existingDiscount,
  whoami,
) {
  // Only execute if there acually is a discount code
  if (!discountcode) return;
  console.log('HandleDiscount being called by ' + whoami);
  let valid;
  const { shop, stamp } = getParams();
  // For testing the integration without having to ask for a discount code
  if (discountcode === 'dcode_test_') {
    const settings = await model.getSettings(shop, stamp);
    view.updateCart(
      null,
      'dcode_test_',
      9999,
      null,
      settings,
      dcodeInput,
      null,
      'DCODE_TEST',
    );
  }

  if (!view.discountBoxExisting()) return;
  console.dlog('dcode is validating', discountcode);
  // if an exsiting discount code is being validated,
  // don't display a loading symbol - it might be invalid and confuse customers
  if (!existingDiscount) view.displayLoadingSymbol();
  if (!discountcode)
    discountcode = dcodeInput
      ? dcodeInput.value
      : document.getElementById('dcodeInput').value;

  // Set validate lock
  sessionStorage.setItem('dcValidating', discountcode);

  // Check if cart has changed in the meantime
  const settings = await model.getSettings(shop, stamp);
  const { advancedDiscountAdding, config } = settings;
  const { hideRestriction, customSubtotal } = config;
  const cartChanged = await model.saveCartAndCurrency(
    customSubtotal,
    shop,
  );
  let currentDiscount = sessionStorage.getItem('currentDiscount');
  currentDiscount = currentDiscount
    ? JSON.parse(currentDiscount)
    : undefined;

  if (
    cartChanged ||
    update ||
    !currentDiscount ||
    currentDiscount.title !== discountcode
  ) {
    // finally handle the discount
    if (advancedDiscountAdding) {
      console.dlog('___ Advanced discount handling ___');
      // Use the new method
      await Checkout.applyDiscount(discountcode);
      const {
        discountCode,
        discountAmount,
        originalAmount,
        success,
      } = await Checkout.verifyDiscount(discountcode);
      console.dlog({
        success,
        discountCode,
        discountAmount,
      });
      view.hideLoadingSymbol();
      valid = !!success;
      if (success) {
        // Updating discount field
        view.updateCart(
          null,
          discountCode,
          discountAmount,
          null,
          settings,
          dcodeInput,
          originalAmount,
          'HELPER API',
        );
        // Save current discount code in the local storage
        sessionStorage.setItem(
          'currentDiscount',
          JSON.stringify({
            title: discountcode,
            value: discountAmount,
          }),
        );
      } else {
        // Discount is invalid
        !existingDiscount &&
          view.updateCart(
            'Please enter a valid discount code',
            discountcode,
            null,
            null,
            settings,
            dcodeInput,
          );
      }
    } else {
      // Get Discountdata and title
      let { error, codeData } = discountcode
        ? await model.checkDiscount(shop, discountcode)
        : { error: 'Please enter a valid code ' };
      if (!error) error = !(await model.timeValid(codeData));
      view.hideLoadingSymbol();
      // Only display error if it wasn't an existing discount
      if ((!hideRestriction || error) && !existingDiscount) {
        console.dlog('dcode Error -', error);
        view.updateCart(
          error,
          discountcode,
          null,
          null,
          settings,
          dcodeInput,
          null,
          'OLD METHOD 1 (no value)',
        );
      }
      // Calculate the discount value (seperated for faster response)
      valid = !error;
      if (!error) {
        const {
          error: e,
          value,
          restriction,
        } = await model.calculateDiscountValue(shop, codeData);
        error = e ? e : error;
        // If restrictions are hidden, display an error.
        if (hideRestriction && isNaN(value)) {
          console.dlog('dcode value -', value);
          view.updateCart(
            true,
            undefined,
            undefined,
            undefined,
            undefined,
            dcodeInput,
            null,
            'HIDDEN RESTRICTION',
          );
        } else {
          view.updateCart(
            null,
            discountcode,
            value,
            restriction,
            settings,
            dcodeInput,
            null,
            'OLD METHOD 2 (with value)',
          );
          console.dlog(error);
          // Save current discount code in the local storage
          sessionStorage.setItem(
            'currentDiscount',
            JSON.stringify({
              title: discountcode,
              value,
              restriction,
            }),
          );
        }
      }
    }
  } else {
    const { title, value, restriction } = currentDiscount;
    view.hideLoadingSymbol();
    view.updateCart(
      undefined,
      title,
      value,
      restriction,
      settings,
      null,
      null,
      'NOT UPDATING',
    );
    console.dlog(
      'Not recalculating',
      discountcode,
      "because cart didn't change",
    );
  }
  if (startObserver) model.observeHiddenDiscount(handleDiscount);
  // Release validate lock
  sessionStorage.removeItem('dcValidating');

  // Log discount validation
  if (
    discountcode && // only if there is a discount code given
    valid !== undefined && // only if the discount code was validated
    (whoami === 'CLICK EVENT' || whoami === 'ENTER EVENT') // only if the source was a click or enter event
  )
    model.logDiscountValidation(
      shop,
      whoami,
      discountcode.toUpperCase(),
      valid,
    );
}

function getParams() {
  console.dlog('CurrentScript: ', currentScript, currentScriptObj);
  if (currentScript) {
    const getParams = currentScript
      .split('?')
      .pop()
      .split('&');
    let params = {};
    getParams.forEach(item => {
      const keyVal = item.split('=');
      params[keyVal[0]] = keyVal[1];
    });
    return params;
  } else {
    return {};
  }
}

/** Todo
 * add id to scripttag that is increased when merchant changes settings. This id
 * is then used to save settings in the local storage so that they are updated when settings change
 *
 * Allow changing of total price
 * Fix styling
 * */

window.getDcodeStyle = () => {
  document
    .querySelectorAll('#dcodeCustomStyle, #dcAdditionalStyle')
    .forEach(e => console.log(e.innerHTML));
};
